import { useQuery } from '@tanstack/react-query';
import { getUsers } from '../../../api/users/users.api';

export interface UserSearchResult {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role?: {
    name: string;
    id: string;
  };
  enabled?: boolean;
}

export const useSearchUsers = (searchTerm: string, enabled = true) => {
  return useQuery({
    queryKey: ['users-search-cmail', { searchTerm }],
    queryFn: () =>
      getUsers({
        params: {
          search: searchTerm,
          page: 0,
          size: 10,
        },
      }).then((response) => ({
        users: (response.data.data || []) as UserSearchResult[],
        totalCount: response.data.meta?.total || 0,
      })),
    enabled: enabled && searchTerm.length >= 2,
    keepPreviousData: true,
    staleTime: 1000 * 60, // 1 minute
    refetchOnWindowFocus: false,
  });
};
